let utils = require('../actions/utils');
let redirect = require('../actions/redirect');
let error = require('../actions/error');

function usingLock (lockPath, actions = []) {
    return [
        utils.isEqual(lockPath, true),
        {
            yes: [],
            no: [
                utils.set(lockPath, true),
                ...actions,
                utils.unset(lockPath)
            ]
        }
    ];
}

module.exports = {
    redirect: [
        redirect.redirectFromArgs
    ],

    // костыль, в некоторых случаях catbee без этого не отрисовывает страницу после редиректа, хз почему
    redirectLogin: [
        utils.set(['layout'], 'auth'),
        utils.set(['page', 'components', 0, 'name'], 'login'),
        utils.set(['page', 'components', 0, 'id'], 'login'),
        redirect.redirect('/login')
    ],

    usingLock,

    logOnWebApi (message, level) {
        return [
            [
                utils.logOnWebApi(message, level),
                {
                    error: [
                        error.internalError('logOnWebApi')
                    ]
                }
            ]
        ];
    },

    toggleItem (path, value) {
        return [
            utils.toggleItem(path, value)
        ];
    },

    toggleBool (path) {
        return [
            utils.toggleBool(path)
        ];
    },

    togglePopupFromArgs: [
        utils.togglePopupFromArgs
    ],

    togglePopup (name) {
        return [
            utils.togglePopup(name)
        ];
    },

    setFromArgsToState (argName, path) {
        return [
            utils.setFromArgsToState(argName, path)
        ];
    },

    unset (path) {
        return [
            utils.unset(path)
        ];
    },

    checkCookieEnabled: [
        [
            utils.checkIsCookieEnabled,
            {
                yes: [],
                no: [
                    error.cookieDisabled('checkCookieEnabled')
                ],
                server: []
            }
        ]
    ]
};



// WEBPACK FOOTER //
// ./signals/utils.js